import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/audit-log");
      setRows(data);
    })();
  }, []);

  const filtered = rows.filter((r) => !q ||
    (r.table_name || "").includes(q) ||
    (r.user_email || "").includes(q) ||
    (r.action || "").includes(q));

  return (
    <div className="p-6 md:p-8 space-y-4" data-testid="audit-page">
      <div>
        <div className="mptg-overline">Compliance</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight mt-1">Audit Log</h1>
        <p className="text-slate-500 mt-1">{rows.length} change{rows.length === 1 ? "" : "s"} recorded (last 200)</p>
      </div>
      <div className="mptg-card">
        <Input placeholder="Filter by table, user, action…" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>
      <div className="mptg-card p-0 overflow-hidden">
        <table className="w-full mptg-table">
          <thead><tr><th>Time</th><th>User</th><th>Action</th><th>Table</th><th>Record</th></tr></thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={r.id}>
                <td className="text-xs font-mono text-slate-500">{(r.timestamp || "").slice(0, 19).replace("T", " ")}</td>
                <td className="text-sm">{r.user_name || r.user_email || "system"}</td>
                <td><span className={`rounded px-2 py-0.5 text-xs font-semibold ${
                  r.action === "create" ? "badge-green" :
                  r.action === "delete" ? "badge-red" :
                  r.action === "update" ? "badge-blue" : "badge-slate"
                }`}>{r.action}</span></td>
                <td className="text-xs font-mono">{r.table_name}</td>
                <td className="text-xs font-mono text-slate-500 truncate max-w-[240px]">{r.record_id}</td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={5} className="py-8 text-center text-slate-400">No audit entries.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
